import { Platform, Modal as RNModal } from "react-native";
import { KeyboardAvoidingView, View } from "react-native";
import { StyleSheet } from "react-native";
import { getSchemeStyle } from "../context/helper";

export const Modal = ({ children, isOpen, withInput, props }) => {
  const schemeStyles = getSchemeStyle();

  const content = withInput ? (
    <KeyboardAvoidingView 
        style={[styles.mainContainer,schemeStyles.modalBackground]}
        behavior={Platform.OS === 'ios'? 'padding': 'height'}
    >
      {children}
    </KeyboardAvoidingView>
  ) : (
    <View style={[styles.mainContainer,schemeStyles.modalBackground]}>{children}</View>
  );

  return (
    <RNModal
      visible={isOpen}
      transparent
      animationType="fade"
      statusBarTranslucent
      {...props}
    >
      {content}
    </RNModal>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    padding: 10,
  },
});
